import React from 'react'
import styled, { keyframes } from 'styled-components'
import PropTypes from 'prop-types'

const Button = styled.button`
  cursor: pointer;
  background: #e2813b;
  color: ${props => props.loading ? 'transparent' : 'white'};
  padding: 10px 20px;
  display: grid;
  grid-template-columns: 1fr;
  align-items: center;
  padding: 10px 20px;
  border-radius: 3px;
  border: none;
  position: relative;
  height: 40px;
  outline: 0;
  font-family: 'Open Sans';
  ${props => props.loading ? 'pointer-events: none;' : ''}
  &:focus {
    outline: 0;
  }
  &:disabled {
    background: #dddddd;
    cursor: default ;
  }
`
const stretch = keyframes`
  0%, 40%, 100% {
    transform: scale3d(1, 0.4, 1);
  }
  20% {
    transform: scale3d(1, 1, 1);
  }
`
const BarContainer = styled.div`
  position: absolute;
  left: 0;
  right: 0;
  top: 0;
  bottom: 0;
  margin: auto;
  display: flex;
  flex-direction: row;
  justify-content: center;
  align-items: center;
  height: 100%;
  width: 100%;
`
const LoadingContainer = styled.div`
  position: relative;
  width: 100%;
  height: 100%;
`
const Bar = styled.div`
  height: 32px;
  width: 6px;
  margin: 0px 1.5px;
  animation: ${stretch} 1.2s infinite ease-in-out;
  animation-delay: ${ props => props.number * .1}s;
  animation-delay: ${props => -1.2 + props.number * .1}s;
  background: white;
`
const ChildrenContainer = styled.div`
  visibility: ${props => props.loading ? 'hidden' : 'visible'};
`

export default class LoadingButton extends React.Component {
  static propTypes = {
    children:  PropTypes.any,
    className: PropTypes.string,
    disabled:  PropTypes.bool,
    id:        PropTypes.string,
    loading:   PropTypes.bool,
    onClick:   PropTypes.func
  }
  renderLoader = () => {
    const { loading } = this.props
    if (loading) {
      return (
        <LoadingContainer>
          <BarContainer>
            {
              [0, 1, 2, 3].map(num => {
                return <Bar key={num} number={num} />
              })
            }
          </BarContainer>
        </LoadingContainer>
      )
    }
  }
  render() {
    const { children, ...rest } = this.props
    return (
      <Button
        {...rest}
        type="button"
      >
        {this.renderLoader()}
        <ChildrenContainer >
          {children}
        </ChildrenContainer>
      </Button>
    )
  }
}
